import ModalSystem from './ModalSystem';
import './ModalSystem.scss';

export default ModalSystem;
